export const travel_vacation = [
  { char: '✈️', name: 'Airplane', nameZh: '出國旅遊', keywords: ['fly', 'travel', 'trip'], hot: true },
  { char: '🏝️', name: 'Island', nameZh: '海島度假', keywords: ['beach', 'vacation', 'summer'], hot: true },
  { char: '🏨', name: 'Hotel', nameZh: '質感住宿', keywords: ['stay', 'hotel', 'resort'] },
  { char: '🎒', name: 'Backpack', nameZh: '背包客/探險', keywords: ['hike', 'travel', 'adventure'] },
  { char: '🗺️', name: 'Map', nameZh: '行程規劃', keywords: ['location', 'plan', 'guide'] },
  { char: '📸', name: 'Camera', nameZh: '打卡紀錄', keywords: ['photo', 'pic', 'instagram'], hot: true },
  { char: '🌊', name: 'Wave', nameZh: '大海氣息', keywords: ['sea', 'surf', 'water'] },
  { char: '⛵', name: 'Sailboat', nameZh: '揚帆啟航', keywords: ['boat', 'sea', 'river'] },
  { char: '⛩️', name: 'Shrine', nameZh: '日本旅遊', keywords: ['japan', 'shrine', 'asia'] },
  { char: '🏰', name: 'Castle', nameZh: '歐洲城堡', keywords: ['europe', 'king', 'history'] },
  { char: '🌋', name: 'Volcano', nameZh: '壯闊景觀', keywords: ['nature', 'fire', 'hike'] },
  { char: '🛂', name: 'Passport Control', nameZh: '護照查驗', keywords: ['travel', 'border', 'airport'] },
];